import easydropdown from 'easydropdown-a11y'

const fn = {

    init: () => {
        const dropdowns = document.querySelectorAll('select.js-dropdown')
        dropdowns.forEach((dropdown) => {
            fn.setupDropdown(dropdown)
        })
    },

    setupDropdown: (select) => {
        if (!select) {
            return
        }

        const opts = {
            behavior: {
                openOnFocus: true,
                maxVisibleItems: 10,
                liveUpdates: true,
                useNativeUiOnMobile: false,
            },
        }
        easydropdown(select, opts)
    }
}

export default {
    can: () => document.querySelectorAll('select.js-dropdown').length > 0,
    run: fn.init,
}
